<template>
  <div class="border-2 border-gray-800">
    
    <AssetHeader 
      :index="index" 
      :updateValue="updateValue"
      :assetId="asset.id"
      :assetType="parseInt(asset.type)"
      :deleteAsset="deleteAsset"></AssetHeader>

    <div class="flex flex-wrap -mx-2 p-4">
      <div class="w-full lg:w-1/3 px-2">
        <InputText 
          label="Description"
          propertyKey="string1"
          objectType="asset"
          objectSubType="investments"
          :objectId="asset.id"
          :index="index"
          :value="asset.string1"
          :updateValue="updateValue" />
      </div>

      <div class="w-full lg:w-1/3 px-2 mt-6 lg:mt-0">
        <InputDollarValue 
          propertyKey="value"
          objectType="asset"
          label="Value"
          objectSubType="savings"
          :required="true"
          :objectId="asset.id"
          :index="index"
          :value="asset.value"
          :updateValue="updateValue"/>
      </div>

      <div class="w-full lg:w-1/3 px-2 mt-6 lg:mt-0">
        <Ownership :asset="asset" />
      </div>
    </div>
  </div>
</template>

<script>
  import AssetHeader      from '../AssetHeader'
  import InputText        from '@/shared/components/form/InputText'
  import InputDollarValue from '@/shared/components/form/InputDollarValue'
  import Ownership        from '@/shared/components/Ownership'

  export default {

    components: {
      AssetHeader,
      InputText,
      InputDollarValue,
      Ownership
    },

    props : {
      asset : {
        type     : Object,
        required : true
      },

      index : {
        type : Number,
        required : false
      },

      updateValue : {
        type     : Function,
        required : false
      },

      deleteAsset : {
        type    : Function,
        required: false
      },
    },
  }
</script>